<template>
    <div class="container">
        <el-form :model="form"
                 :rules="rules"
                 ref="form"
                 label-position="left"
                 label-width="0px"
                 @submit.prevent.native="onSubmit"
                 class="login-container">
            <h3 class="title">Login</h3>
            <el-form-item prop="username">
                <el-input type="text"
                          v-model="form.username"
                          auto-complete="off"
                          placeholder="login">
                </el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input type="password"
                          v-model="form.password"
                          auto-complete="off"
                          placeholder="password">
                </el-input>
            </el-form-item>
            <el-form-item style="width:100%;">
                <button type="submit" class="el-button el-button--primary" style="width: 100%;" :loading="loading">
                    <span>Login</span>
                </button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                loading: false,
                form: {},
                rules: {
                    username: [
                        {required: true, message: 'To pole jest wymagane', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: 'To pole jest wymagane', trigger: 'blur'},
                    ]
                },
                checked: true
            };
        },
        methods: {
            async submitLoginForm () {
                this.loading = true;
                let payload = {username: this.form.username, password: this.form.password};
                const loginResponse = this.$store.dispatch('auth/login', payload).catch(error => {
                    let message = 'Wystąpił błąd podczas logowania.'

                    if (error.response.data.non_field_errors) {
                        message = `${message} ${error.response.data.non_field_errors}`
                    }

                    this.$message({
                        message: message,
                        type: 'error'
                    })
                })
                this.loading = false;
                this.redirectOnSuccess()
            },
            redirectOnSuccess () {
                if (this.$route.query.next !== undefined) {
                    this.$router.push(this.$route.query.next)
                } else {
                    this.$router.push('/')
                }
            },
            onSubmit (e) {
                this.submitLoginForm()
                // this.$refs.form.validate((valid) => {
                //     if (valid) {
                //         this.submitLoginForm()
                //     } else {
                //         return false;
                //     }
                // });
            }
        }
    }

</script>

<style lang="scss" scoped>
    .container {
        background: #061927;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }

    .login-container {
        margin: 180px auto;
        width: 350px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        .title {
            margin: 0px auto 40px auto;
            text-align: center;
            color: #505458;
        }
        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// Login.vue?4989c631